import { CompositeKeyModel, CompositeSubKeyModel, UserModel } from "..";

export interface MemberFriendInfosModel {
  code: string;
  left: number;
  clipcardSubKey: CompositeSubKeyModel;
  validUntilDate?: string;
}

export interface BringOrReferAFriendData {
  referrerKey: CompositeKeyModel;
  clipcardKey: CompositeSubKeyModel;
  friendCode: string;
  type?: BringOrReferAFriendType;
}

export interface MemberFriendInputInfos {
  referrerKey: CompositeKeyModel;
  searchClipcardKey?: CompositeSubKeyModel;
  type?: BringOrReferAFriendType;
}

export enum BringOrReferAFriendType {
  BringAFriend = "bringAFriend",
  ReferAFriend = "referAFriend",
}
